// gatsby-browser.js
import React from 'react';
import { AppContext } from './src/context/AppContext';
import Layout from './src/components/Layout';
import './src/css/components/Styles.css';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { initMixpanel, trackPageViewed } from './src/utils/mixpanel';

// Safari: evitar restauración de scroll que provoca “sube y baja” al entrar en categorías
export const onClientEntry = () => {
  if (typeof window !== 'undefined' && window.history?.scrollRestoration) {
    window.history.scrollRestoration = 'manual';
  }
  // Mixpanel (task-1635): antes de la primera vista de página.
  initMixpanel();
};

// Verificar que la variable de entorno existe
const clientId = process.env.GATSBY_GOOGLE_CLIENT_ID;
if (!clientId) {
  console.error('GATSBY_GOOGLE_CLIENT_ID no está definido en las variables de entorno');
}

export const wrapRootElement = ({ element }) => {
  return (
    <GoogleOAuthProvider clientId={clientId}>
      <AppContext>
        <Layout>
          {element}
        </Layout>
      </AppContext>
    </GoogleOAuthProvider>
  );
};

export const onRouteUpdate = ({ location }) => {
  if (typeof window !== 'undefined') {
    import('./src/hooks/usePageTracking').then(({ trackPageView }) => {
      trackPageView(location.pathname);
    }).catch(() => {});

    // Mixpanel: una vista por cambio de ruta, incluida la primera carga. El
    // pequeño retraso deja que Gatsby actualice el <title> de la página nueva.
    setTimeout(() => trackPageViewed(location.pathname), 50);
  }
};